import React from "react";
import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
} from "@mui/material";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const EnhancedTableHead = (props) => {
  const { t } = props;
  const rows = [
    {
      id: "TaskTitle",
      numeric: false,
      disablePadding: false,
      label: t("Task.TaskTitle"),
      field: "task_name",
    },
    {
      id: "TaskType",
      numeric: false,
      disablePadding: false,
      label: t("Task.TaskType"),
      field: "task_type_id",
    },

    {
      id: "Status",
      numeric: false,
      disablePadding: false,
      label: t("Task.Status"),
      field: "status",
    },
    {
      id: "Priority",
      numeric: false,
      disablePadding: false,
      label: t("Task.Priority"),
      field: "priority",
    },
    {
      id: "ReminderDate",
      numeric: false,
      disablePadding: false,
      label: t("Task.ReminderDate"),
      field: "reminder_date",
    },
    {
      id: "DueDate",
      numeric: false,
      disablePadding: false,
      label: t("Task.DueDate"),
      field: "due_date",
    },
    // {
    //   id: "Action",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Action",
    //   field: "action",
    // },
    {
      id: "Patient",
      numeric: false,
      disablePadding: false,
      label: t("Task.Patient"),
      field: "name",
    },
    {
      id: "User",
      numeric: false,
      disablePadding: false,
      label: t("Task.User"),
      field: "name",
    },
    {
      id: "Email",
      numeric: false,
      disablePadding: false,
      label: t("Patient.Email"),
      field: "name",
    },
    {
      id: "is_enabled",
      numeric: false,
      disablePadding: false,
      label: t("Patient.Enabled"),
      field: "is_enabled",
    },
    { id: "actions", numeric: false, disablePadding: false, label: "Actions" },
  ];
  const createSortHandler = (property, field) => (event) => {
    props.onRequestSort(event, property, field);
  };

  const {
    onSelectAllCheckBoxClick,
    order,
    orderBy,
    totalRowsSelected,
    rowCount,
    sortID,
  } = props;

  return (
    <TableHead sx={{ height: "56px" }}>
      <TableRow>
        <TableCell sx={{ padding: "0 12px" }}>
          <Checkbox
            indeterminate={
              totalRowsSelected > 0 && totalRowsSelected < rowCount
            }
            checked={totalRowsSelected === rowCount}
            onChange={onSelectAllCheckBoxClick}
            sx={{
              "&.Mui-checked": { color: "#0ae" },
              "&.MuiCheckbox-indeterminate": { color: "#0ae" },
            }}
          />
        </TableCell>
        {rows.map((row) => {
          return (
            <TableCell
              key={row["id"]}
              numeric={row["numeric"] ? row["numeric"] : "undefined"}
              padding={"none"}
              sortDirection={orderBy === row["id"] ? order : false}
              sx={{
                color: "rgba(0, 0, 0, 0.54)",
                fontSize: "0.75rem",
                fontWeight: 500,
              }}
            >
              {["Actions"].includes(row.label) ? (
                <TableSortLabel
                  sx={{ ".MuiSvgIcon-root": { fontSize: 16, cursor: "text" } }}
                >
                  {row.label}
                </TableSortLabel>
              ) : (
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row["numeric"] ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row["field"] && sortID === row["id"]}
                    direction={order}
                    onClick={createSortHandler(row["id"], row["field"])}
                    sx={{ ".MuiSvgIcon-root": { fontSize: 16 } }}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              )}
            </TableCell>
          );
        }, this)}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  totalRowsSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllCheckBoxClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default withTranslation()(EnhancedTableHead);



// WEBPACK FOOTER //
// ./src/components/taskmanager/EnhancedTableHead.js